module.exports = __webpack_public_path__ + "static/media/plane.54065c14.png";